<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="p-t-75 p-b-10  o-hidden text-left" style="padding-top: 5px">
    <div class="h-full o-hidden ">
      <div class="h-full ">
        <div class="flex h-full ">
          <div class="flex-1">
            <div class="text-left bold fs-15 bg-white b-b" style="padding: 20px 43px 20px 60px">
              <div class="fs-14 flex a-center color-666">
                <div class="flex a-center j-between w-full">
                  <div class="flex a-center">
                    <slot name="button">
                      <div @click="goback" class="flex a-center m-r-30 VideoImgBox">
                        <img alt="" class="w-30 h-30 VideoImg"
                             src="../../../assets/common/ic_fanhui.png">
                        <img alt="" class="VideoImgHover w-30 h-30"
                             src="../../../assets/common/ic_fanhui.png">

                        <span class="fs-14 d-block" style="margin-left: 13px">返回</span>
                      </div>
                      <!--<div @click="allClear" class="flex a-center m-r-30 VideoImgBox">-->
                      <!--<img alt="" class="w-30 h-30 VideoImg" src="../../../assets/common/ic_qingkong_normal.png">-->
                      <!--<img alt="" class="VideoImgHover w-30 h-30" src="../../../assets/common/ic_qingkong_hover.png">-->

                      <!--<span class="fs-14 d-block" style="margin-left: 13px">清空</span>-->
                      <!--</div>-->
                      <div @click="delItem" class="flex a-center m-r-60 VideoImgBox" v-if="id>0">
                        <img alt="" class="VideoImg w-30 h-30"
                             src="../../../assets/common/ic_shanchu_class@2x.png">
                        <img alt="" class="VideoImgHover w-30 h-30"
                             src="../../../assets/common/ic_shanchu_class@2x.png">
                        <span class="fs-14 d-block" style="margin-left: 13px">删除</span>
                      </div>

                      <div @click="onEbookSave" class="flex a-center VideoImgBox">
                        <img alt="" class="w-30 h-30 VideoImg"
                             src="../../../assets/common/ic_baocun_normal.png">
                        <img alt="" class="VideoImgHover w-30 h-30"
                             src="../../../assets/common/ic_baocun_hover.png">
                        <span class="fs-14 d-block" style="margin-left: 13px">保存</span>
                      </div>
                    </slot>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full h-full">
              <div class="h-full bg-white p-l-60 p-t-25">
                <div class=" flex h-full">
                  <div class="o-y-auto noscroll" style="width: 632px">
                    <div class="m-b-30">
                      <div class="fs-16" style="color: #333333;margin-bottom: 30px;">文件上传</div>
                      <div>
                        <div class="flex flex-wrap">
                          <file-upload :canclick="canclick" @uploadSuccess="uploadFileSuccess"
                                       accept="application/pdf"
                                       style="width: 98px;height: 120px;margin-right: 30px">
                            <div class="flex a-center j-center" slot="tip"
                                 style="width: 98px;height: 120px;background: #F8F8F9;">
                              <div class="flex a-center flex-column">
                                <img alt="" src="../../../assets/common/ic_pdf_normal.png"
                                     style="width: 30px;height: 30px">
                                <span class="d-block m-t-10">PDF</span>
                              </div>
                            </div>
                          </file-upload>
                          <img-upload :canclick="canclick" @uploadSuccess="uploadImageSuccess"
                                      multiple
                                      picurl="company/about/"
                                      style="width: 98px;height: 120px;">
                            <div class="flex a-center j-center" slot="tip"
                                 style="width: 98px;height: 120px;background: #F8F8F9;">
                              <div class="flex a-center flex-column">
                                <img alt="" src="../../../assets/common/tupian2.png"
                                     style="width: 30px;height: 30px">
                                <span class="d-block m-t-10">上传图片</span>
                              </div>
                            </div>
                          </img-upload>
                        </div>
                        <div class="flex flex-wrap ">
                          <draggable :clone="cloneData"
                                     :move="onMove"
                                     @end="onDragEnd"
                                     @start="isDragging=true"
                                     class="list-group1 flex a-center flex-wrap m-t-20"
                                     element="div"
                                     v-bind="dragOptions2"
                                     v-model="imgList">
                            <div @click="onitemclick(index,item)"
                                 class="relative Imgbox m-r-20 m-b-20"
                                 contenteditable="false"
                                 style="width: 133px;height: 189px;"
                                 v-for="(item,index) in imgList">
                              <img :src="item.picurl" @click="onchangeImg(item,index)" alt=""
                                   class="w-full h-full b-radius-4">
                              <img :class="[indexId === index?'displayBlock1':'displayNone']"
                                   @click="onItemDelClick(index,item)"
                                   alt="" class="d-none picImgHover"
                                   src="../../../assets/common/ic_yichu.png"
                                   style="position: absolute;right: -11px;top: -11px"
                                   v-if="indexId === index">
                              <div :class="[indexId === index?'displayBlock':'displayNone']"
                                   @click="onchangeImg(item,index)"
                                   class="w-full h-full">
                                <img alt="" src="../../../assets/common/ic_xuanzhong1.png">
                              </div>
                            </div>

                          </draggable>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="b-l p-l-60 flex h-full">
                    <div class="m-b-30" style="width: 362px;margin-right: 60px">
                      <div class="fs-16" style="color: #333333;margin-bottom: 30px;">手册编辑</div>
                      <div class="m-b-20 m-t-30">
                        <div class="fs-14">手册名称</div>
                        <div>
                          <Input class="inputBoder b-b" maxlength="50" placeholder="请输入手册名称"
                                 show-word-limit
                                 style="width: 362px"
                                 v-model="ebookTitle"/>
                        </div>
                      </div>
                      <div>
                        <class-vertical-choose-widget :objData="objData" :srcType="3">
                          <span slot="footer">手册分类</span>
                          <span slot="groupTitle">手册分组</span>
                          <img @click="onClassificyGroup" alt="" class="m-r-9 w-16 h-16" slot="footer_right"
                               src="../../../assets/common/ic_add_circle_blue.png"
                               style="cursor: pointer">
                          <img @click="onClassificyGroup" alt="" class="m-r-9 w-16 h-16" slot="groupTitle_right"
                               src="../../../assets/common/ic_add_circle_blue.png"
                               style="cursor: pointer">
                        </class-vertical-choose-widget>
                      </div>
                      <div>
                        <span class="bold fs-14">分享设置</span>
                        <div class="flex m-t-15 m-b-25">
                          <span class="fs-14">分享标题：</span>
                          <div>
                            <input placeholder="分享标题" style="width: 265px;margin-bottom: 5px" type="text"
                                   v-model="shareTitle"/>
                            <div style="width: 265px;height:1px;background-color: #2c3e50;"></div>
                          </div>
                        </div>
                        <!--                        图片宽高比5:4-->
                        <up-load-image @uploadSuccess="onUploadShareCoverSuccess($event)"
                                       accept="image/*"
                                       picurl="share/icon/">
                          <template v-slot:tip>
                            <RatioDiv :o_hidden="false" :radio-value="80">
                              <div>
                                <div class="w-full h-full flex-column"
                                     style="position: absolute;background-color: #D8D8D8">
                                  <img alt="" src="../../../assets/common/ic_upload_picture@2x.png"
                                       style="width: 96px;height: 96px">
                                  <span class="m-t-5  color-66">上传图片</span>
                                </div>

                                <img
                                  :src="sharePicUrl"
                                  @click.stop=""
                                  style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;background-color: #F6F9FF;"
                                  v-if="sharePicUrl"
                                />

                                <img @click.stop="onDelShareCoverSuccess()"
                                     src="../../../assets/common/ic_yichu.png"
                                     style="position: absolute;right: -11px;top: -11px"
                                     v-if="sharePicUrl"/>
                              </div>
                            </RatioDiv>
                          </template>
                        </up-load-image>

                      </div>
                    </div>
                    <div class="m-b-30">
                      <div class="fs-16" style="color: #333333;margin-bottom: 23px;">手册描述</div>
                      <div class="HandePhongBg p-v-60">
                        <div class="relative  top-0 left-0 p-h-5"
                             style=" width: 300px; height: 460px;">
                          <iframe class="w-full" frameborder="0" id="logframe" noresize
                                  ref="logframe" scrolling="no" src="/ebookprew"
                                  style="height:calc(100% - 1px)">
                          </iframe>
                          <div class="absolute"
                               style="bottom: 100px;right: -100px;border:1px solid #F8F8F9;width: 60px;height: 360px">
                            <div @click="handleFullscreen" class="flex a-center j-center"
                                 style="height: 120px;border-bottom: 1px solid #F8F8F9">
                              <Icon color="#F8F8F9" size="30" type="ios-expand"/>
                            </div>
                            <div @click="handleBack" class="flex a-center j-center"
                                 style="height: 120px;border-bottom: 1px solid #F8F8F9">
                              <Icon color="#F8F8F9" size="30" type="ios-arrow-back"/>
                            </div>
                            <div @click="handleForward" class="flex a-center j-center"
                                 style="height: 120px;">
                              <Icon color="#F8F8F9" size="30" type="ios-arrow-forward"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        :closable="false"
        @on-visible-change="onModalClose"
        class="modal-setting"
        class-name="vertical-center-modal"
        v-model="showClassManger"
        width="640px">
        <p class="text-center" slot="header">
          <span>分类管理</span>
        </p>
        <div class="flex a-center j-center" style="width: 600px;height: 360px">
          <class-group-setting-widget :objInfo="objInfo"
                                      :srcType="3"
                                      class="w-full h-full">
          </class-group-setting-widget>
        </div>
      </Modal>
    </div>
  </div>

</template>

<script>
import ImgUpload from '@/components/common/ImgUpload'
import FileUpload from '../../../components/common/FileUpload'
import draggable from 'vuedraggable'
import Bus from '@/utils/bus'
import {mapActions} from 'vuex'
import ClassGroupSettingWidget from '@/components/common/ClassGroupSettingWidget2'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'
import RatioDiv from '@/components/common/RatioDiv'
import UpLoadImage from '@/components/common/UpLoadImage'

export default {
  name: 'EbookDetail',
  components: {
    ImgUpload,
    FileUpload,
    draggable,
    ClassGroupSettingWidget,
    ClassVerticalChooseWidget,
    RatioDiv,
    UpLoadImage,
  },
  props: {
    out: {
      type: Boolean,
      default: false
    },
    callBack: Function
  },
  data () {
    return {
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      objInfo: {
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },
      appId: 0,
      id: 0,
      isDragging: false,
      canclick: true,
      shareTitle: '',   //分享标题
      sharePicUrl: '',  //分享图片url
      content: {
        content: ''
      },
      maxRichHeight: '570px',

      showEbookShow: false,
      indexId: '',
      listener: null,
      canSentData: false,
      ebookTitle: '',

      imgList: [],  //图片容器
      classifyDatas: [],    //分类数据
      showClassManger: false,
      selectItem: {
        categoryId: 0,
        groupId: 0,
        init: false
      },
      oldContentMd5: '',
      progress: 0,
      selItem: null,
      time: null,
    }
  },
  computed: {
    dragOptions2 () {
      return {
        animation: 0,
        group: 'description',
        // handle: '.my-handle',
        ghostClass: 'ghost'
      }
    },

  },
  mounted () {
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    let newMd5Str = this.md5Format()
    if (newMd5Str === this.oldContentMd5) {
      next()
    } else {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>数据还没保存，您确定要返回吗？</p>',
        onOk: () => {
          next()
        },
        onCancel: () => {
        }
      })
    }
  },

  methods: {
    init () {
      this.appId = this.$route.params.appId || 0
      this.getClassifyInitData()

      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getDetails()
      } else {
        this.oldContentMd5 = this.md5Format()
      }

      this.isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
      const mapFrame = this.$refs.logframe
      let that = this
      if (mapFrame.attachEvent) { // 兼容浏览器判断
        mapFrame.attachEvent('onload', function () {
          const iframeWin = mapFrame.contentWindow
          let data = {
            type: 'change',
            time: new Date(),
            picList: that.imgList,
            bgUrl: that.bgUrl,
            width: 296,
            height: 460
          }
          let href = window.location.href
          iframeWin.postMessage(data, href + '/ebookprew')
          // data传递的参数   *写成子页面的域名或者是ip
        })
      } else {
        mapFrame.onload = function () {
          const iframeWin = mapFrame.contentWindow
          let data = {
            type: 'change',
            time: new Date(),
            picList: that.imgList,
            bgUrl: that.bgUrl,
            width: 296,
            height: 460
          }
          let href = window.location.href
          iframeWin.postMessage(data, href + '/ebookprew')
        }
      }

      this.listener = (messageEvent) => {
        let data = messageEvent.data
        if (data.type === 'status') {
          if (data.result === 'OK') {
            that.canSentData = true
            that.postPicChangeMessage(this.imgList)
          }
        }
      }
      window.addEventListener('message', this.listener, false)
    },

    /**
     * 获取视频详情
     */
    getDetails () {
      let id = this.$route.query.id
      let params = {}
      this.getHandBookDetail({
        id,
        params
      }).then(res => {
        if (res.code === 0) {
          this.imgList = res.data.contentList.map(child => {
            child.picurl = child.url
            child.buttonInfo = {
              desc: '',
              bgColor: '#2d8cf0',
              jumpurl: ''
            }
            return child
          })
          this.ebookTitle = res.data.title
          this.selectItem.groupId = res.data.groupId
          this.selectItem.categoryId = res.data.categoryId
          this.selectItem.init = true

        }
        this.oldContentMd5 = this.md5Format()

      })
    },
    md5Format () {
      let str = this.id + '::' + this.title + '::' + this.imgList + '::' + this.selectItem.categoryId + '::' + this.selectItem.groupId
      return this.$md5(str)
    },

    onModalClose (status) {
      if (!status) {
        if (this.isFullscreen) {
          this.handleFullscreen()
        }
      }
    },
    // 上传文件
    uploadFileSuccess (data) {
      if (data && data.length) {
        let picPath = data[0].url
        this.startPdfToPic(picPath)
      }
    },
    startPdfToPic (url) {
      if (url) {
        let params = {
          pdfUrl: url
        }
        this.pdfToPic(params).then(res => {
          if (res.code === 0) {
            let uploadId = res.data.taskId
            this.showTask(uploadId)
          } else {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    showTask (uploadId) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', 'Loading')
          ])
        }
      })
      this.getupLoadTaskStatus(uploadId)

    },
    getupLoadTaskStatus (uploadId) {
      this.time = setInterval(() => {
        this.getPdfToPisList(uploadId).then(res => {
          if (res.code === 0) {
            if (res.data && res.data.genStatus === 2) {
              let imgList = res.data.contentList.map(child => {
                return {
                  title: '',
                  picurl: child.object.url,
                  width: child.object.width || 720,
                  height: child.object.height || 360,
                  buttonInfo: {
                    desc: '',
                    bgColor: '#2d8cf0',
                    jumpurl: ''
                  }
                }
              })
              this.imgList = this.imgList.concat(imgList)
              this.postPicChangeMessage()
              clearInterval(this.time)
              this.$Spin.hide()
            }
          }
        })
      }, 1000)

    },
    // 上传图片
    uploadImageSuccess (data) {
      if (data && data.length) {
        let imgList = data.map(res => {
          return {
            title: res.oldname,
            picurl: res.url,
            width: res.width,
            height: res.height,
            buttonInfo: {
              desc: '',
              bgColor: '#2d8cf0',
              jumpurl: ''
            }
          }
        })
        let length = this.imgList.length || 0
        let num = 8 - length
        if (num > 0) {
          imgList = imgList.slice(0, num)
        } else {
          this.$Message.info('最多上传8张')
          return
        }
        this.imgList = this.imgList.concat(imgList)
        this.postPicChangeMessage()
      }
      this.progress = 0
      this.canclick = true

    },
    handleBack () {
      const mapFrame = this.$refs.logframe
      if (mapFrame) {
        const iframeWin = mapFrame.contentWindow
        let data = {
          type: 'Backward',
          time: new Date()
        }
        let href = window.location.href
        if (this.canSentData) {
          iframeWin.postMessage(data, href + '/ebookprew')
        }
      }
    },
    handleForward () {
      const mapFrame = this.$refs.logframe
      if (mapFrame) {
        const iframeWin = mapFrame.contentWindow
        let data = {
          type: 'Forward',
          time: new Date()
        }
        let href = window.location.href
        if (this.canSentData) {
          iframeWin.postMessage(data, href + '/ebookprew')
        }
      }
    },
    handleFullscreen () {
      let main = document.body
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.isFullscreen = false
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
        this.isFullscreen = true
      }
    },

    cloneData (original) {
      return JSON.parse(JSON.stringify(original))
    },
    onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    onDragEnd (param) {
      this.isDragging = false
      this.postPicChangeMessage()
    },
    onitemclick (index, item) {
      this.selectedIndex = index
    },
    postPicChangeMessage () {
      const mapFrame = this.$refs.logframe
      if (mapFrame) {
        const iframeWin = mapFrame.contentWindow
        let data = {
          type: 'change',
          time: new Date(),
          picList: this.imgList,
          bgUrl: this.bgUrl,
          width: 296,
          height: 460
        }
        let href = window.location.href
        if (this.canSentData) {
          iframeWin.postMessage(data, href + '/ebookprew')
        }
      }

    },

    geteditData (data) {
    },
    onEbookSave () {
      if (!this.ebookTitle) {
        return this.$Message.info('请输入手册名称')
      }
      if (!(this.imgList && this.imgList.length)) {
        return this.$Message.info('请上传手册图片')
      }
      if (!(this.selectItem.groupId && this.selectItem.categoryId)) {
        return this.$Message.info('请选择分类分组')
      }

      let contentList = this.imgList.map(child => {
        child.url = child.picurl
        return child
      })

      let params = {
        title: this.ebookTitle || '',
        groupId: this.selectItem.groupId,
        categoryId: this.selectItem.categoryId,
        contentList: contentList,
      }
      if (!this.id) {
        this.getAddHandBook(params).then(res => {
          if (res.code === 0) {
            this.oldContentMd5 = this.md5Format()
            this.goback()
          }
          this.$Message.info(res.msg)
        })
      } else {
        let id = this.id
        this.editHandBook({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            this.oldContentMd5 = this.md5Format()
            this.goback()
          }
          this.$Message.info(res.msg)

        })
      }
    },
    goback () {
      if (!this.out) {
        this.$router.replace('/ebook')
      } else {
        Bus.$emit('bookchange')
        this.ebookTitle = ''
        this.imgList = []
        this.canSentData = true
        this.postPicChangeMessage()
        this.callBack()
      }
    },

    //清除该图片数据
    onItemDelClick (index, item) {
      this.imgList.splice(index, 1)
      if (item === this.selItem) {
        if (this.imgList && this.imgList.length) {
          this.selItem = this.imgList[0]
        } else {
          this.selItem = null
        }
      }
      this.postPicChangeMessage()

    },
    //删除素材
    delItem (item) {
      this.$Modal.confirm({
        title: '删除素材',
        content: '<p>是否删除该素材？</p>',
        onOk: () => {
          let params = {
            idList: this.id
          }
          this.delHandBook(params).then(res => {
            if (res.code === 0) {
              this.goback()

            }
            this.$Message.info(res.msg)

          })
        },
        onCancel: () => {
        }
      })
    },
    // 切换图片
    onchangeImg (item, index) {
      this.indexId = index
      this.selItem = item
    },
    //打开分类分组
    onClassificyGroup () {
      this.showClassManger = true
    },
    async getClassifyInitData () {
      let res = await this.getClassifyData()
      this.classifyDatas = res
      if (this.classifyDatas && this.classifyDatas.length > 1) {
        if (!this.selectItem.categoryId) {
          this.selectItem.categoryId = this.classifyDatas[1].id
        }
      }
      if (this.selectItem.categoryId) {
        let groupList = await this.getGroupData(this.categoryId)
        let list = groupList.slice(1)
        if (list && list.length) {
          if (!this.selectItem.groupId) {
            this.selectItem.groupId = list[0].id
          }
        }
      }
      this.selectItem.init = true
    },
    // 渲染分类列表
    getClassifyData () {
      return new Promise(((resolve, reject) => {
        let params = {
          type: 3

        }
        this.getHandBookCategory(params).then(res => {
          if (res.code === 0) {
            var arr = res.data
            resolve(arr)
          }
        })
      }))
    },

    // 渲染分组列表
    getGroupData (id) {
      return new Promise(((resolve, reject) => {
        let params = {
          categoryId: id,
          type: 3

        }
        this.getHandBookGroup(params).then(res => {
          if (res.code === 0) {
            resolve(res.data)
          }
        })
      }))
    },
    // 添加分类
    addPicClassify (value) {
      return new Promise(((resolve, reject) => {
        this.addClassify = value
        let params = {
          name: this.addClassify,
          icon: '',
          desc: '',
          isDefault: '0',
          sort: '',
          type: 3

        }
        this.addHandBookCategory(params).then(res => {
          if (res.code === 0) {
            this.$Message.success('添加分类成功！')
            this.getClassifyData().then(res => {
              this.classifyDatas = res
              resolve(res)
            })
            this.onAddClassify()
            this.addClassify = ''
          }
        })
      }))
    },

    //添加分组
    addGroupsFun (classId, groupeName) {
      return new Promise(((resolve, reject) => {
        let params = {
          name: groupeName,
          icon: '',
          desc: '',
          isDefault: '0',
          sort: '',
          categoryId: classId,
          type: 3

        }
        this.addHandBookGroup(params).then(res => {
          if (res.code === 0) {
            this.getGroupData(classId).then(rres => {
              resolve(rres)
            })
          }
        })
      }))
    },
    // 修改分类
    redactClassify (data) {
      return new Promise(((resolve, reject) => {
        let params = {
          name: data.name,
          icon: data.icon,
          desc: data.desc,
          isDefault: data.isDefault,
          sort: data.sort,
          type: 3

        }
        var id = data.id
        this.redactHandBookCategory({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            this.getClassifyData().then(child => {
              this.classifyDatas = child
              resolve(child)
            })
            this.valueId = ''
          } else {
            this.$Message.info(res.msg)
          }
        })
      }))
    },
    // 修改分组
    redactGroups (data, classId) {
      return new Promise((resolve, reject) => {
        let params = {
          name: data.name,
          icon: data.icon,
          desc: data.desc,
          isDefault: data.isDefault,
          sort: data.sort,
          id: data.id,
          type: 3

        }
        var id = data.id
        this.redactHandBookGroup({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            //此处更新分类
            resolve(res)
          }
        })
      })
    },
    // 删除分类
    deleteClassify (data) {
      return new Promise(((resolve, reject) => {
        let params = {
          idList: data.id,
          type: 3

        }
        this.delHandBookCategory(params).then(res => {
          if (res.code === 0) {
            this.getClassifyData().then(rres => {
              this.classifyDatas = rres
              resolve(rres)
            })
          }

        })
      }))
    },
    // 删除分组
    deleteGroup (data) {
      return new Promise(((resolve, reject) => {
        let params = {
          idList: data.id,
          type: 3

        }
        this.delHandBookGroup(params).then(res => {
          if (res.code === 0) {
            resolve()
            this.$Message.success(res.msg)
          }
        })
      }))
    },
    // 添加分类显示框
    onAddClassify () {
      this.addClassifyShow = !this.addClassifyShow
    },
    onUploadShareCoverSuccess (data) {            //分享设置上传图片成功
      if (data && data.length) {
        this.sharePicUrl = data[0].url
      }
    },
    onDelShareCoverSuccess () {                   //分享设置删除图片
      this.sharePicUrl = ''
    },
    ...mapActions([
      'addeBook',
      'editeBook',
      'geteBooKDetail',
      'getAddHandBook',
      'delHandBook',
      'getHandBookDetail',
      'editHandBook',
      'getHandBookCategory',
      'getHandBookGroup',
      'addHandBookCategory',
      'addHandBookGroup',
      'redactHandBookCategory',
      'redactHandBookGroup',
      'delHandBookCategory',
      'delHandBookGroup',
      'pdfToPic',
      'getPdfToPisList'
    ])
  }
}
</script>
<style lang="scss">
  .inputBoder > .ivu-input {
    border: none;
    padding: 0;
  }

  .inputBoder > .ivu-input:focus {
    box-shadow: none;
  }

  .selectBorder .ivu-select-selection {
    border: none;
    box-shadow: none;
  }

  .selectBorder .ivu-select-selection .ivu-select-placeholder {
    padding-left: 0;
  }

  .titleBg .w-e-toolbar {
    background: #F8F8F9 !important;
    padding-top: 6px;
    border-left: 1px solid #D8D8D8;
    border-top: 1px solid #D8D8D8;
    border-right: 1px solid #D8D8D8;
  }


  .Imgbox:hover .picImgHover {
    display: block;
  }

  .displayBlock {
    display: flex;
    position: absolute;
    right: 0px;
    top: 0px;
    align-items: center;
    justify-content: center;
    background: rgba(0, 122, 255, 0.2);
    border-radius: 4px;
  }

  .displayBlock1 {
    display: block;

  }

  .displayNone {
    display: none;
  }

  .HandePhongBg {
    background-image: url("../../../assets/common/img_yangji.png");
    background-size: 300px 100%;
    background-repeat: no-repeat;
  }

  .VideoImg {
    display: block;
  }

  .VideoImgBox:hover .VideoImg, {
    display: none;
  }

  .VideoImgHover {
    display: none;
  }

  .VideoImgBox:hover .VideoImgHover {
    display: block;
  }


  .active {

    background: #EDF3FF;
    color: #0652DD;
  }

  .liHover:hover {
    background: #EDF3FF;

  }

  .liHover:hover .selectHover {
    display: block;

  }

  .selectHover1 {
    display: block;

  }

  .liHover2:hover {
    background: #EDF3FF;
  }

  .inputBoder > .ivu-input {
    border: none;
    padding: 0;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }

</style>
<style>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
